import type { Partner } from '@tagadapay/crm-entities';

import type { BrandConfig } from '@/config/brands/types';

export const mergePartnerBranding = (
  base: BrandConfig,
  overlay: Partner.PartnerBranding,
): BrandConfig => ({
  ...base,
  ...(overlay.appName ? { appName: overlay.appName } : {}),
  ...(overlay.appDescription ? { appDescription: overlay.appDescription } : {}),
  ...(overlay.logoUrl ? { logo: overlay.logoUrl } : {}),
  ...(overlay.logoDarkUrl ? { logoDark: overlay.logoDarkUrl } : {}),
  ...(overlay.faviconUrl ? { favicon: overlay.faviconUrl } : {}),
  ...(overlay.primaryColor ? { primaryColor: overlay.primaryColor } : {}),
  ...(overlay.accentColor ? { accentColor: overlay.accentColor } : {}),
  ...(overlay.fontFamily ? { fontFamily: overlay.fontFamily } : {}),
  ...(overlay.bookCallUrl ? { bookCallUrl: overlay.bookCallUrl } : {}),
});
